// HR customer menu removed. Add sales-related customer-facing menu
// items here when the sales feature set is rebuilt.

export const menuItemCustomers = []
